import React, {useMemo, useState} from 'react';
import {Helmet} from "react-helmet";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import GoogleMapReact from "google-map-react";
import Supercluster from "supercluster";


import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMapMarkerAlt} from "@fortawesome/free-solid-svg-icons";

const HotelsMap = () => {
  const [mapState, setMapState] = useState(
    {
      // center: {
      //   lat: lat,
      //   lng: lon
      // },
      zoom: 11
    }
  );
  const [zoom, setZoom] = useState(10);
  const [bounds, setBounds] = useState(null);
  const Marker = ({ children }) => (
    <div style={{ transform: "translate(-50%, -50%)" }}>{children}</div>
  );
  const points = [
    { id: 1, lat: 43.2389, lng: 76.8897 },
    { id: 2, lat: 43.24, lng: 76.89 },
    { id: 3, lat: 43.25, lng: 76.88 },
    // ...
  ];
  const clusterIndex = useMemo(() => {
    const index = new Supercluster({
      radius: 60, // радиус в пикселях
      maxZoom: 20,
    });

    index.load(
      points.map((point) => ({
        type: "Feature",
        properties: { cluster: false, id: point.id },
        geometry: {
          type: "Point",
          coordinates: [point.lng, point.lat],
        },
      }))
    );

    return index;
  }, [points]);
  // Кластеры для текущей области и зума
  const clusters = useMemo(() => {
    if (!bounds) return [];
    return clusterIndex.getClusters(
      [bounds.nw.lng, bounds.se.lat, bounds.se.lng, bounds.nw.lat],
      zoom
    );
  }, [clusterIndex, bounds, zoom]);
  return (
    <>
      <Helmet>
        <title>Подбор отелей</title>
      </Helmet>
      <Portlet>
        <PortletHeader title={'Поиск отелей'} toolbar={<PortletHeaderToolbar></PortletHeaderToolbar>}/>
        <PortletBody>
          <div style={{height: '400px', width: '100%'}}>
            <GoogleMapReact
              // defaultCenter={{
              //   lat: 59.95,
              //   lng: 30.33
              // }}
              defaultCenter={{ lat: 43.238949, lng: 76.889709 }}
              onChange={({ zoom, bounds }) => {
                setZoom(zoom);
                setBounds(bounds);
              }}
              defaultZoom={11}
              // center={mapState.center.lat ? mapState.center : undefined}
            >
              {/*<div*/}
              {/*  style={{*/}
              {/*    width: '30px', height: '40px', position: 'relative', top: -40, left: -15,*/}
              {/*    display: 'flex',*/}
              {/*    flexDirection: 'column',*/}
              {/*    justifyContent: 'flex-end',*/}
              {/*    alignItems: 'center',*/}
              {/*    textAlign: 'center'*/}
              {/*  }}*/}
              {/*  lat={currentLocation.lat}*/}
              {/*  lng={currentLocation.lon}>*/}

              {/*  <FontAwesomeIcon icon={faMapMarkerAlt}*/}
              {/*                   style={{color: '#de4229', fontSize: 30}}/>*/}
              {/*</div>*/}
              {clusters.map((cluster) => {
                const [lng, lat] = cluster.geometry.coordinates;
                const { cluster: isCluster, point_count: pointCount } =
                  cluster.properties;

                if (isCluster) {
                  return (
                    <Marker key={`cluster-${cluster.id}`} lat={lat} lng={lng}>
                      <div
                        style={{
                          width: `${20 + (pointCount / points.length) * 40}px`,
                          height: `${20 + (pointCount / points.length) * 40}px`,
                          background: "rgba(0, 128, 255, 0.6)",
                          borderRadius: "50%",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const expansionZoom = Math.min(
                            clusterIndex.getClusterExpansionZoom(cluster.id),
                            20
                          );
                          setZoom(expansionZoom);
                        }}
                      >
                        {pointCount}
                      </div>
                    </Marker>
                  );
                }

                return (
                  <Marker key={cluster.properties.id} lat={lat} lng={lng}>
                    📍
                  </Marker>
                );
              })}
            </GoogleMapReact>
          </div>
        </PortletBody>
      </Portlet>

    </>
  );
};

export default HotelsMap;
